import { Link } from 'react-router-dom';

export function AppFooter() {
  return (
    <footer className="border-t bg-card/50 mt-auto">
      <div className="px-3 sm:px-4 lg:px-8 py-4">
        <div className="flex flex-wrap gap-x-4 gap-y-1 justify-center text-xs text-muted-foreground">
          <Link to="/privacidad" className="hover:text-foreground transition-colors font-medium">Centro</Link>
          <Link to="/privacy-policy" className="hover:text-foreground transition-colors">Privacidad</Link>
          <Link to="/terms-and-conditions" className="hover:text-foreground transition-colors">Términos</Link>
          <Link to="/cookies-policy" className="hover:text-foreground transition-colors">Cookies</Link>
          <Link to="/consent-information" className="hover:text-foreground transition-colors">Consentimiento</Link>
        </div>
        <p className="text-center text-[10px] text-muted-foreground mt-2">
          © {new Date().getFullYear()} FOCO AI System
        </p>
      </div>
    </footer>
  );
}
